import { router } from 'expo-router';
import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { ThemedText } from '../themed-text';

interface LinkProps {
  style?: ViewStyle;
  label?: string;
}

export function TermsOfUseLink({
  style,
  label
}: LinkProps) {

  return (
    <View style={[styles.container, style]}>
      <ThemedText type='small' style={[styles.center, styles.size]}>
        {label || "By joining our app, you agree to our"} <ThemedText type='link' style={[styles.size]} onPress={() => router.push('/terms')}>Terms of Service</ThemedText> and <ThemedText type='link' style={[styles.size]} onPress={() => router.push('/privacy')}>Privacy Policy</ThemedText>
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    textAlign: 'center',
  },
  size: {
    fontSize: 12,
  }
});
